import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import GameManagement from '../components/GameManagement.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'LoginPage',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'GameManagement',
      component: GameManagement,
      meta: {
        requiresAuth: true
      }
    },
    // 重定向到登录页面
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查该路由是否需要登录权限
  if (to.meta.requiresAuth) {
    // 获取本地存储的token
    const token = localStorage.getItem('token')
    
    // 如果有token，则继续访问
    if (token) {
      next()
    } else {
      // 如果没有token，则跳转到登录页面
      next({ path: '/login' })
    }
  } else {
    // 如果不需要登录权限，则直接访问
    next()
  }
})

export default router